import { protectorCropwiseApiClient } from '@protector/api-client';
import type { CustomFormTimelineRecord } from './models';
import { customFormTimelinePageSchema } from './schemas';

export const getCustomFormTimelineRecords = async (companyId: string, propertyId: string): Promise<CustomFormTimelineRecord[]> => {
  const records: CustomFormTimelineRecord[] = [];
  const visitedCursors = new Set<string>();
  let cursor: string | undefined;

  for (;;) {
    const response = await protectorCropwiseApiClient.request({
      config: {
        url: '/web-server/v1/custom-forms/query',
        method: 'POST',
        params: { size: 100, ...(cursor && { cursor }) },
        data: { org_ids: [companyId], property_ids: [propertyId] }
      },
      outputSchema: customFormTimelinePageSchema
    });
    const page = response.data;
    records.push(...page.content);
    if (page.last) return records;
    if (!page.cursor || visitedCursors.has(page.cursor)) throw new Error('Custom forms query returned an invalid pagination cursor');
    visitedCursors.add(page.cursor);
    cursor = page.cursor;
  }
};
